module.exports = __webpack_public_path__ + "img/kin9.9c0df5c2.jpg";